<script setup lang="ts">
type Props = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const props = withDefaults(defineProps<Props>(), {
  tag: 'h2',
});
</script>

<template>
  <component :is="props.tag" class="text-h1">
    <slot></slot>
    <span class="dot text-primary">.</span>
  </component>
</template>

<style scoped lang="scss">
.dot {
  font-size: 40px;
}
</style>
